import {DetailedActionCard} from "../../Common/component/DetailedActionCard";
import React, {useContext, useEffect, useState} from "react";
import {ReactComponent as IcBook} from "./resources/ic_book.svg";
import {ReactComponent as IcClock} from "./resources/ic_clock.svg";
import {ReactComponent as IcNoteBook} from "./resources/ic_notebook.svg";
import {CircularProgress} from "@mui/material";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ExamCurriculumDialogSidebar} from "./DialogSidebar/ExamCurriculumDialogSidebar";
import {NahrainThemeContext} from "../../../context/NahrainThemeContext";
import {SelectCurriculumDialogSidebar} from "./DialogSidebar/SelectCurriculumDialogSidebar";
import {ExamInfoDialogSidebar} from "./DialogSidebar/ExamInfoDialogSidebar";
import {ExamSelectStudentsDialogSidebar} from "./DialogSidebar/ExamSelectStudentsDialogSidebar";
import {DialogSidebarSuccessScreen} from "../../Admin/users/createNewUserDialogSidebar/DialogSidebarSuccessScreen";
import {getRequest} from "../../../api/postRequest";
import {ProfConfig} from "../../../api/config/AuthConfig";
import {AuthContext} from "../../../context/AuthContext";
import {NahrainLogger} from "../../../debug/NahrainLogger";


export const ExamsScreen = ({className}) => {
    const [t] = useTranslation("global");
    const {setDialogSidebar} = useContext(NahrainThemeContext);
    const {accessToken} = useContext(AuthContext)
    const [dialogSidebarState, setDialogSidebarState] = useState({
        currentDialogSidebarScreen: 0,
    });

    const [examInfo, setExamInfo] = useState({
        curriculumId: 0,
        type: "",
        title: "",
        description: "",
        examDate: null,
        durationMinutes: null,
        percentageGrade: null
    });

    const [profExamsState, setProfExamsState] = useState({
        exams: [],
        loading: true,
        error: null
    })

    const handleDialogSidebarChange = (field, value) => {
        setDialogSidebarState(prev => ({...prev, [field]: value}));
    };
    const handleExamInfoChange = (field, value) => {
        setExamInfo(prev => ({...prev, [field]: value}));
    };

    const handleProfExamsStateChange = (field, value) => {
        setProfExamsState(prev => ({...prev, [field]: value}));
    };

    const createExamDialogSidebarScreens = [
        <ExamCurriculumDialogSidebar
            onClickContinue={(examType) => {
                handleExamInfoChange("type", examType)
                handleDialogSidebarChange("currentDialogSidebarScreen", 1)
            }}/>,
        <SelectCurriculumDialogSidebar
            onClickContinue={(curriculumId) => {
                handleExamInfoChange("curriculumId", curriculumId)
                handleDialogSidebarChange("currentDialogSidebarScreen", 2)
            }}/>,
        <ExamInfoDialogSidebar onClickSubmitInfo={(examInfo) => {
            handleExamInfoChange("title", examInfo.title)
            handleExamInfoChange("description", examInfo.description)
            handleExamInfoChange("examDate", formatExamDate(examInfo.examDate))
            handleExamInfoChange("durationMinutes", examInfo.examDuration * 60)
            handleExamInfoChange("percentageGrade", examInfo.percentage)
            handleDialogSidebarChange("currentDialogSidebarScreen", 3)
        }}/>,
        <ExamSelectStudentsDialogSidebar examInfo={examInfo}
                                         onClickNext={() => {
                                             fetchProfExams()
                                             handleDialogSidebarChange("currentDialogSidebarScreen", 4)
                                         }}/>,
        <DialogSidebarSuccessScreen title={t("exam_created_title")} description={t("exam_created_description")}
                                    onDismiss={() => {
                                        setDialogSidebar(prev => ({...prev, isVisible: false}));
                                        setDialogSidebarState(prev => ({...prev, currentDialogSidebarScreen: 0}));
                                    }}/>
    ]


    useEffect(() => {
        setDialogSidebar(prev => ({
            ...prev,
            onDismiss: () => {
                setDialogSidebar(prev => ({...prev, isVisible: false}));
                setDialogSidebarState(prev => ({...prev, currentDialogSidebarScreen: 0}));
            },
            child: createExamDialogSidebarScreens[dialogSidebarState.currentDialogSidebarScreen],
            indicatorMaxScreens: createExamDialogSidebarScreens.length,
            indicatorCurrentScreen: dialogSidebarState.currentDialogSidebarScreen
        }));

    }, [dialogSidebarState.currentDialogSidebarScreen]);

    const fetchProfExams = () => {
        getRequest({
            path: ProfConfig.EXAM,
            token: accessToken,
            onSuccess: (res) => {
                handleProfExamsStateChange("exams", res.payload)
                handleProfExamsStateChange("loading", false)
            },
            onError: (err) => {
                handleProfExamsStateChange("error", true)
                NahrainLogger.error(err)
            }
        })
    }

    useEffect(() => {
        fetchProfExams();
    }, []);
    const mapExamToCard = (exam) => {
        const examDate = new Date(exam.examDate);
        const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

        return (
            <MaterialDetailedCard
                key={exam.id}
                title={exam.title || "Untitled Exam"}
                dayOfWeek={days[examDate.getDay()]}
                dayOfMonth={examDate.getDate()}
                examFormat={exam.curriculum.type}
                assessmentType={exam.number.replace('_', ' ')} // "QUIZ_1" → "QUIZ 1"
                duration={exam.durationMinutes / 60}
                material={exam.curriculum.name}
                stage={exam.curriculum.stageType}
            />
        );
    };

    return (
        <div className={`${className} w-full bg-background p-6`}>
            <DetailedActionCard title={t("create_new_exam")}
                                description={t("create_new_exam_description")}
                                buttonTitle={t("create_new_exam")}
                                onClick={() => {
                                    setDialogSidebar(prev => ({
                                        ...prev,
                                        onDismiss: () => {
                                            setDialogSidebar(prev => ({...prev, isVisible: false}));
                                        },
                                        isVisible: true,
                                        child: createExamDialogSidebarScreens[0],
                                        indicatorMaxScreens: createExamDialogSidebarScreens.length,
                                        indicatorCurrentScreen: dialogSidebarState.currentDialogSidebarScreen
                                    }));
                                }}
            />

            <div className="flex flex-col gap-4 mt-4 h-fit">
                {profExamsState.loading ? (
                    <div className="flex justify-center">
                        <CircularProgress sx={{color: "rgba(var(--on-background))"}}/>
                    </div>
                ) : profExamsState.error ? (
                    <div className="text-error text-center">
                        {profExamsState.error}
                        <button
                            onClick={fetchProfExams}
                            className="ml-2 px-3 py-1 bg-primary text-onPrimary rounded"
                        >
                            {t("retry")}
                        </button>
                    </div>
                ) : profExamsState.exams && profExamsState.exams.length > 0 ? (
                    profExamsState.exams.map(mapExamToCard)
                ) : (
                    <div className="text-onBackgroundCaption text-center mt-4 text-4xl">
                        {t("no_exams_found")}
                    </div>
                )}
            </div>
        </div>)
}


export const MaterialDetailedCard = ({
                                         className,
                                         title,
                                         dayOfWeek,
                                         dayOfMonth,
                                         assessmentType,
                                         examFormat,
                                         duration,
                                         material,
                                         stage
                                     }) => {
    const [t] = useTranslation("global");

    return (
        <div
            className={`${className} flex flex-wrap px-6 py-4 rounded-2xl gap-6 border-[1px] border-strokeGray`}>
            <div className={"flex flex-row gap-6"}>
                <div className={"flex flex-col gap-4 items-center w-fit"}>
                    <p className={"text-xl text-primary"}>{dayOfWeek}</p>
                    <p className={"text-[56px] text-primary leading-10"}>{dayOfMonth}</p>
                </div>
                <div className={`w-[1.5px] bg-strokeGray h-[inherit]`}/>
                <div className={`flex flex-col gap-2 w-fit`}>
                    <div className={`flex flex-row gap-2 items-center text-onBackground`}><IcBook/> <p
                        className={"line-clamp-1"}>{assessmentType} - {t(examFormat.toLowerCase())}</p>
                    </div>
                    <div className={`flex flex-row gap-2 items-center text-onBackground`}><IcClock/>
                        <p>{duration} {t("hour_abbreviation")}</p></div>
                    <div className={`flex flex-row gap-2 items-center text-onBackground`}><IcNoteBook
                        className={"size-8"}/> <p
                        className={"line-clamp-1 "}>{material} - {t(stage.toLowerCase())}</p></div>
                </div>
            </div>
            <div className={"flex flex-col gap-2"}>
                <p className={"text-[20px] font-semibold text-onBackground"}>{title}</p>
                <div className="flex gap-2 rtl:flex-row-reverse">
                    <div className="relative w-[60px]">
                        <img
                            src="https://picsum.photos/200"
                            alt="avatar"
                            className="rounded-[50%] size-6 relative z-[31]"
                        />
                        <img
                            src="https://picsum.photos/201"
                            alt="avatar"
                            className="rounded-[50%] size-6 absolute top-0 ltr:left-[12px] rtl:right-[12px] z-30"
                        />
                        <img
                            src="https://picsum.photos/202"
                            alt="avatar"
                            className="rounded-[50%] size-6 absolute top-0 ltr:left-[24px] rtl:right-[24px] z-20"
                        />
                        <img
                            src="https://picsum.photos/203"
                            alt="avatar"
                            className="rounded-[50%] size-6 absolute top-0 ltr:left-[36px] rtl:right-[36px] z-10"
                        />
                    </div>
                    <p className="text-[16px] text-secondary">{t("view_all_students")}</p>
                </div>


            </div>
        </div>
    )
}

function formatExamDate(date) {
    // If it's already in yyyy-mm-dd format, return as-is
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
    }

    // Create a Date object (handles both ISO strings and Date objects)
    const dateObj = new Date(date);

    // Validate the date
    if (isNaN(dateObj.getTime())) {
        throw new Error('Invalid date format. Expected ISO string or Date object');
    }

    // Extract components
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}